import type React from 'react';
import type { RawAppointment } from '@/components/types/typeCalendar';
import { getEstadoColor, getIconoPago } from '@/components/constants/citas';

export type AppointmentColumn = {
  id: string;
  label: string;
  enabled: boolean;
  render: (appt: RawAppointment) => React.ReactNode;
  exportValue: (appt: RawAppointment) => string | number | null;
};

export const DEFAULT_APPOINTMENT_COLUMNS: AppointmentColumn[] = [
  {
    id: 'trabajador',
    label: 'Trabajador',
    enabled: true,
    render: (a) => a.trabajadores || '-',
    exportValue: (a) => a.trabajadores || '',
  },
  {
    id: 'servicio',
    label: 'Servicio',
    enabled: true,
    render: (a) => a.nombre_servicio,
    exportValue: (a) => a.nombre_servicio,
  },
  {
    id: 'cliente',
    label: 'Cliente',
    enabled: true,
    render: (a) => a.nombre_cliente || '-',
    exportValue: (a) => a.nombre_cliente || '',
  },
  {
    id: 'telefono',
    label: 'Teléfono',
    enabled: true,
    render: (a) => a.telefono || '-',
    exportValue: (a) => a.telefono || '',
  },
  {
    id: 'email',
    label: 'Email',
    enabled: true,
    render: (a) => a.email_contacto || '-',
    exportValue: (a) => a.email_contacto || '',
  },
  {
    id: 'estado',
    label: 'Estado',
    enabled: true,
    render: (a) => (
      <span
        className={`px-2 py-1 rounded-full text-xs font-semibold text-white ${getEstadoColor(
          a.estado_cita
        )}`}
      >
        {a.estado_cita}
      </span>
    ),
    exportValue: (a) => a.estado_cita,
  },
  {
    id: 'fecha',
    label: 'Fecha',
    enabled: true,
    render: (a) => a.fecha_cita,
    exportValue: (a) => a.fecha_cita,
  },
  {
    id: 'hora_inicio',
    label: 'Hora inicio',
    enabled: true,
    render: (a) => a.hora_cita?.slice(0, 5) || '-',
    exportValue: (a) => a.hora_cita?.slice(0, 5) || '',
  },
  {
    id: 'hora_fin',
    label: 'Hora fin',
    enabled: true,
    render: (a) => a.hora_fin?.slice(0, 5) || '-',
    exportValue: (a) => a.hora_fin?.slice(0, 5) || '',
  },
  {
    id: 'tipo_pago',
    label: 'Método de pago',
    enabled: true,
    render: (a) =>
      a.tipo_pago ? (
        <span className="inline-flex items-center gap-2">
          <span style={{ fontSize: '18px' }}>{getIconoPago(a.tipo_pago)}</span>
          <span className="capitalize">{a.tipo_pago}</span>
        </span>
      ) : (
        '-'
      ),
    exportValue: (a) => a.tipo_pago || '',
  },
  {
    id: 'precio',
    label: 'Precio',
    enabled: true,
    render: (a) =>
      a.precio != null ? (
        <span className="font-medium whitespace-nowrap">
          {a.precio.toFixed(2)} €
        </span>
      ) : (
        '-'
      ),
    exportValue: (a) => a.precio ?? '',
  },
];
